module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik01MTIuMDA0IDUxMS45ODVIMFYwaDUxMi4wMDR6Ii8+CiAgICA8cGF0aCBmaWxsPSIjMzg4ZDAwIiBkPSJNNTEyLjAwNCA1MTEuOTg1SDBWMzQxLjMyM2g1MTIuMDA0eiIvPgogICAgPHBhdGggZmlsbD0iI2Q0MzUxNiIgZD0iTTUxMi4wMDQgMTcwLjhIMFYuMTM3aDUxMi4wMDR6Ii8+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/hu.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/hu.svg
// module chunks = 0